import {get} from "lodash"

export const waitPromise = (time = 20) => {
  return new Promise<undefined>((resolve) => {
    setTimeout(resolve, time)
  })
}

export const hangPromise = <T = void>(): Promise<T> => {
  return new Promise(() => {})
}

export const isPromise = (promise: any): boolean => !!promise && "then" in promise

/**
 * @author: Richard 23/1/2018
 * @description: Execute an Array of functions that return a promise in serial. All promises must resolve/reject before
 * it returns anything.
 * This can be used for throttling API calls (send one by one)
 * @example
 *
 * const users = [{name: "Bob"}, {name: "Fred"}]
 * const funcs = users.map((user) => () => this.handleCreate(user))
 *
 * promiseSerialAll(funcs)
 *  .then((Array responses) => {})
 *  .catch((Array rejects) => {})
 */
export const promiseSerialAll = (arr = []) => {
  if (get(arr, "length", 0) === 0) {
    return waitPromise()
  }
  const success = []
  const errors = []

  const runPromise = (func) => {
    return func()
      .then((res) => success.push(res))
      .catch((err) => errors.push(err))
  }

  let previous = runPromise(arr[0])
  arr.slice(1).forEach((func) => {
    previous = previous.then(() => runPromise(func))
  })

  previous.then(() => {
    if (errors.length) {
      throw new Error(errors)
    }

    return success
  })

  return previous
}
